import { Field as FieldPrimitive } from "@base-ui/react/field";
import { cva, type VariantProps } from "cva";
import { cn } from "#ui-atoms/lib/utils";

const fieldRootVariants = cva({
  base: "space-y-2",
  variants: {
    centered: { true: "items-center", false: undefined },
  },
  defaultVariants: {},
});

export type BaseFieldRootProps = FieldPrimitive.Root.Props &
  VariantProps<typeof fieldRootVariants>;

export function BaseFieldRoot({
  className,
  centered,
  ...props
}: BaseFieldRootProps) {
  return (
    <FieldPrimitive.Root
      className={cn(
        "flex w-full flex-col gap-2 space-y-2",
        fieldRootVariants({ centered }),
        className,
      )}
      data-slot="field"
      {...props}
    />
  );
}
